const theme = {
    colors: {
      primary: '#8ECAE6',
      primaryHover: '#6EBACF',
      accent: '#FFB703',
      background: '#F4F4F9',
      backgroundSolid: '#FFFFFF',
      text: '#333333',
      lightText: '#666666',
      danger: '#E76F51',
      success: '#81B29A',
      card: '#F9FBFF',
      cardAlt: '#EDF6F9',
      border: '#E0E0E0',
    },
    fontSize: {
      xlarge: '2.5rem',
      heading: '2rem',
      subheading: '1.25rem',
      text: '1rem',
      small: '0.875rem',
      tiny: '0.75rem',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
    spacing: {
      section: '4rem 2rem',
      container: 'max-width: 1200px',
      cardPadding: '1.5rem',
      gapSmall: '0.5rem',
      gapMedium: '1rem',
      gapLarge: '2rem',
    },
    borderRadius: {
      small: '6px',
      medium: '12px',
      large: '20px',
      round: '50%',
    },
    shadow: {
      light: '0 1px 4px rgba(0,0,0,0.06)',
      medium: '0 2px 8px rgba(0,0,0,0.1)',
      heavy: '0 4px 16px rgba(0,0,0,0.15)',
    },
    transitions: {
      default: 'all 0.3s ease',
      fast: 'all 0.2s ease-in-out',
      slow: 'all 0.5s ease',
    },
    buttons: {
      default: {
        backgroundColor: '#8ECAE6',
        color: '#333',
        border: 'none',
        borderRadius: '8px',
        padding: '0.75rem 1.5rem',
        fontSize: '1rem',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'all 0.3s ease',
      },
    },
    
    breakpoints: {
      mobile: '480px',
      tablet: '768px',
      desktop: '1024px',
      wide: '1280px',
    },
  };
  
  export default theme;
  